import { ChallengeContextProvider } from 'context/ChallengeContext/ChallengeContext';
import Cash from 'pages/cash';
import CashDetail from 'pages/cashDetail';
import Challenge from 'pages/challenge';
import NewChallenge from 'pages/challenge/NewChallenge';
import { ChallengeConditions } from 'pages/challenge/NewChallenge/ChallengeConditions/ChallengeConditions';
import { ChallengeRoutines } from 'pages/challenge/NewChallenge/ChallengeRoutines/ChallengeRoutines';
import Coach from 'pages/coach';
import Logout from 'pages/logout';
import Notice from 'pages/notice';
import NoticeModify from 'pages/noticeModify';
import React from 'react';
import { Navigate, useRoutes } from 'react-router';
import { Layouts } from './layouts';
import Login from './pages/login';
import Parts from './pages/parts';

export default function AppRoutes() {
  return useRoutes([
    {
      path: '/',
      element: <Layouts />,
      children: [
        { path: '/', element: <Navigate to='/challenges' replace /> },
        { path: '/parts', element: <Parts /> },
        { path: '/challenges', element: <Challenge /> },
        {
          path: '/challenges/new',
          element: <NewChallenge />,
        },
        {
          path: '/challenges/modify/:id/info',
          element: <NewChallenge />,
        },
        {
          path: '/challenges/modify/:id/conditions',
          element: <ChallengeConditions />,
        },
        {
          path: '/challenges/modify/:id/routines',
          element: (
            <ChallengeContextProvider>
              <ChallengeRoutines />
            </ChallengeContextProvider>
          ),
        },
        { path: '/cash', element: <Cash /> },
        { path: '/cash/challenge/:id', element: <CashDetail /> },
        { path: '/coach', element: <Coach /> },
        { path: '/notice', element: <Notice /> },
        {
          path: '/notice/modify/:id/',
          element: <NoticeModify />,
        },

        { path: '404', element: <div>404</div> },
        { path: '*', element: <Navigate to='/404' /> },
      ],
    },
    {
      path: '/auth',
      children: [
        { path: 'login', element: <Login /> },
        { path: 'logout', element: <Logout /> },
      ],
    },
    { path: '*', element: <Navigate to='/404' replace /> },
  ]);
}
